import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CounterBidDisclosureComponent } from '../counter-bid-disclosure/counter-bid-disclosure.component';

@Component({
  selector: 'app-investor-terms',
  templateUrl: './investor-terms.component.html',
  styleUrls: ['./investor-terms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [CounterBidDisclosureComponent],
})
export class InvestorTermsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
